// import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    doBrowse: { api: 'T2010TeacherBasicService.C40701_doBrowse_AtDataTable', input: {}},
  },
}

const module = {
  state: {
    PageConst,

  },

  getters: {},

  mutations: {},

  actions: {
    async init ({ state }) {
      // const res = await ApiUtils.postData({
      //   data: [
      //   ]
      // })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
